module.exports = __webpack_public_path__ + "img/GSK_bg_lg.686f8dfc.png";